import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Default',
    redirect: '/index'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../components/Home'),
    children: [
      {
        path: '/index',
        name: 'AppIndex',
        component: () => import('../components/home/AppIndex'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/3d_building/:type/:id/:data',
        name: 'VirtualBuilding',
        component: () => import('../components/project/VirtualBuilding'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/project_templates',
        name: 'ProjectTemplates',
        component: () => import('../components/project/ProjectTemplates'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/add_project_template',
        name: 'AddProjectTemplate',
        component: () => import('../components/project/AddProjectTemplate'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/edit_project_template/:id',
        name: 'EditProjectTemplate',
        component: () => import('../components/project/EditProjectTemplate'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/project_items',
        name: 'ProjectItems',
        component: () => import('../components/project/ProjectItems'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/add_project_item',
        name: 'AddProjectItem',
        component: () => import('../components/project/AddProjectItem'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/edit_project_item/:id',
        name: 'EditProjectItem',
        component: () => import('../components/project/EditProjectItem'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/major_materials_usage',
        name: 'MajorMaterialsUsage',
        component: () => import('../components/project/MajorMaterialsUsage'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/add_major_material_usage',
        name: 'AddMajorMaterialUsage',
        component: () => import('../components/project/AddMajorMaterialUsage'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/edit_major_material_usage/:id',
        name: 'EditMajorMaterialUsage',
        component: () => import('../components/project/EditMajorMaterialUsage'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/major_materials',
        name: 'MajorMaterials',
        component: () => import('../components/project/MajorMaterials'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/add_major_material',
        name: 'AddMajorMaterial',
        component: () => import('../components/project/AddMajorMaterial'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/edit_major_material/:id',
        name: 'EditMajorMaterial',
        component: () => import('../components/project/EditMajorMaterial'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/major_material_prices/:id',
        name: 'MajorMaterialPrices',
        component: () => import('../components/project/MajorMaterialPrices'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/pull_major_material_prices',
        name: 'PullMajorMaterialPrices',
        component: () => import('../components/project/PullMajorMaterialPrices'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/major_material_prices_chart/:id/:search',
        name: 'MajorMaterialPricesChart',
        component: () => import('../components/project/MajorMaterialPricesChart'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/add_major_material_price/:id',
        name: 'AddMajorMaterialPrice',
        component: () => import('../components/project/AddMajorMaterialPrice'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/edit_major_material_price/:id',
        name: 'EditMajorMaterialPrice',
        component: () => import('../components/project/EditMajorMaterialPrice'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/add_project_cost_estimate',
        name: 'AddProjectCostEstimate',
        component: () => import('../components/project/AddProjectCostEstimate'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/edit_project_cost_estimate/:from/:id',
        name: 'EditProjectCostEstimate',
        component: () => import('../components/project/EditProjectCostEstimate'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/project_files/:from/:id',
        name: 'ProjectFiles',
        component: () => import('../components/project/ProjectFiles'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/total_project_files',
        name: 'TotalProjectFiles',
        component: () => import('../components/project/TotalProjectFiles'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/total_projects',
        name: 'TotalProjects',
        component: () => import('../components/project/TotalProjects'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/total_projects_model',
        name: 'TotalProjectsModel',
        component: () => import('../components/project/TotalProjectsModel'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/my_projects',
        name: 'MyProjects',
        component: () => import('../components/project/MyProjects'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/orgnizations',
        name: 'OrgnizationList',
        component: () => import('../components/user/OrgnizationList'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/add_orgnization',
        name: 'AddOrgnization',
        component: () => import('../components/user/AddOrgnization'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/edit_orgnization/:id',
        name: 'EditOrgnization',
        component: () => import('../components/user/EditOrgnization'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/users',
        name: 'UserList',
        component: () => import('../components/user/UserList'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/user_register',
        name: 'UserRegister',
        component: () => import('../components/user/UserRegister'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/user_change_password',
        name: 'UserChangePassword',
        component: () => import('../components/user/UserChangePassword'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/user_edit/:id',
        name: 'UserEdit',
        component: () => import('../components/user/UserEdit'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/reset_password/:id',
        name: 'UserResetPassword',
        component: () => import('../components/user/UserResetPassword'),
        meta: {
          requireAuth: true
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../components/Login'),
    meta: {
      requireAuth: false
    }
  }
]

const router = new VueRouter({
  routes: routes
})

export default router
